import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { ImageModule } from 'primeng/image';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { CustomCurrencyPipe } from '../../../pipe/custom-currency.pipe';
import { CommissionsFormService } from '../../../services/commissions-table/commissions-form.service';
import { BCRow } from '../../../models/bank-records/bank-records-row-search-response';
import { Router } from '@angular/router';
import { InputTextModule } from 'primeng/inputtext';
import { ModifyPolicyModalComponent } from '../../../components/modals/bank-record/policy-producer/modify-policy-modal/modify-policy-modal.component';
import { BankRecordsService } from '../../../services/bank-records/bank-records.service';
import { Subscription } from 'rxjs';
import { HttpUtilsBankRecords } from '../../../network/http-utilis-bank-records';
import { ModalService } from '../../../services/modal/modal.service';

@Component({
  selector: 'app-policy-producer-change',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    DropdownModule,
    CalendarModule,
    CommonModule,
    TableModule,
    AutoCompleteModule,
    ProgressSpinnerModule,
    ImageModule,
    CustomCurrencyPipe,
    FormsModule,
    InputTextModule,
    ModifyPolicyModalComponent,
  ],
  templateUrl: './policy-producer-change.component.html',
  styleUrl: './policy-producer-change.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PolicyProducerChangeComponent implements OnInit, OnDestroy {
  form: FormGroup;
  isLoading: boolean = false;
  bankRows: BCRow[] = [];
  showTable: boolean = false;
  searchDone: boolean = false;
  selectedRow: BCRow | undefined;
  subReload: Subscription | undefined;

  constructor(
    public commissionService: CommissionsFormService,
    public router: Router,
    public bankRecordService: BankRecordsService,
    public httpUtilsBankRecord: HttpUtilsBankRecords,
    private modalService: ModalService
  ) {
    this.form = new FormGroup({
      numPoli: new FormControl(null, [Validators.required]),
      titleCollectionDate: new FormControl<Date[]>([], [Validators.required]),
    });
  }
  ngOnDestroy(): void {
    this.subReload?.unsubscribe();
  }

  ngOnInit(): void {
    this.setDefaultDate();
    this.subReload = this.bankRecordService.policyProducerReloadRows.subscribe(
      () => {
        this.loadData();
      }
    );
  }

  loadData(): void {
    const policyNumber = (this.form.get('numPoli')?.value as string)
      .trim()
      .toUpperCase();
    const [fromDate, toDate] =
      this.form.get('titleCollectionDate')?.value || [];

    if (!policyNumber || !fromDate || !toDate) return;

    this.isLoading = true;

    this.httpUtilsBankRecord
      .getPolicyRows(policyNumber, fromDate, toDate)
      .subscribe({
        next: (response) => {
          //Mock: mockBCROWS
          this.bankRows = response['statementRows'].map(
            (bankRow: any) => new BCRow(bankRow)
          );
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.modalService.showError(error);
        },
      });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loadData();
    this.searchDone = true;
    this.showTable = true;
  }

  responseIsEmpty(): boolean {
    return this.bankRows.length === 0 && !this.isLoading;
  }

  onModify(currentRow: BCRow): void {
    this.selectedRow = currentRow;
    this.bankRecordService.policyModifyModalVisibility.next(true);
  }

  private setDefaultDate(): void {
    let today: Date = new Date();
    let threeMonthsAgo: Date = new Date();

    threeMonthsAgo.setDate(today.getDate() - 90);
    this.form.get('titleCollectionDate')?.setValue([threeMonthsAgo, today]);
  }
}
